import { EImageType } from '../../types/offer';

interface ITransformOfferImageType {
  imageType: EImageType;
}

export function transformOfferImageType({ imageType }: ITransformOfferImageType): 'flatplan' | 'default' {
  switch (imageType) {
    case EImageType.FloorPlan:
    case EImageType.Layout:
      return 'flatplan';
    case EImageType.Normal:
    default:
      return 'default';
  }
}
